export const routes = {
  login: '/login',
  dashboard: '/dashboard',
  carSegments: '/:slug',
  segmentDetail: '/:inspection_slug/detail/:segment_slug/:title',
  carPictures: '/:slug/carPictures',
  documents: '/:slug/carPictures/:segment_slug',
  carDetails: '/:slug/car-detail',
  imageViewer: '/:slug/image/:index',
};
